import React from 'react';
import {
    CustomTableSpace,
    CustomTopContainer,
    FilterContainer,
} from '../../../../projectInfo/tabs/notifications/ProjectNotifications.styles';
import { Image, Select, Space } from 'antd';
import { grayDark03, grayDark06 } from '../../../../../styles/colors';
import { Text } from '../../../../../styles/common.styles';
import { SpaceEnd } from '../../../../projectInfo/tabs/ReportingTab/tabs/ProjectCMF/ProjectCMFAlignment.styles';
import CustomPagination from '../../../../../components/common/pagination/CustomPagination';
const { Option } = Select;

const PAGE_SIZE = 10;

const DIVIDER_KEY = 'divider';

const showActionOptions = [
    { key: 'all', label: 'All notifications' },
    { key: 'productAdded', label: 'Added products' },
    { key: 'productRemoved', label: 'Removed products' },
    { key: 'productHidden', label: 'Hidden products' },
    { key: 'productRestored', label: 'Restored products' },
    { key: DIVIDER_KEY, label: '' },
    { key: 'file', label: 'Files' },
    { key: 'comment', label: 'Comments' },
];

interface NotificationControlsProps {
    page: number;
    total: number;
    showAction: string;
    onPageChange: (page: number) => void;
    onPageInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onShowActionChange: (value: string) => void;
}

const NotificationControls: React.FC<NotificationControlsProps> = ({
    page,
    total,
    showAction,
    onPageChange,
    onPageInput,
    onShowActionChange,
}) => (
    <>
        <CustomTableSpace direction="horizontal" style={{ marginBottom: 10 + `px` }}>
            <Space>
                <FilterContainer>
                    <Text weight={400} size={13} height={18} color={grayDark03}>
                        Show
                    </Text>
                    <Select
                        aria-required
                        value={showAction}
                        onChange={onShowActionChange}
                        style={{ width: 200 }}
                        suffixIcon={
                            <Image src="src/assets/images/ic-dropdown-arrow.svg" preview={false} />
                        }
                    >
                        {showActionOptions.map((option) =>
                            option.key === DIVIDER_KEY ? (
                                <Option
                                    disabled
                                    value={option.key}
                                    key={option.key}
                                    aria-hidden
                                    style={{
                                        height: 1,
                                        minHeight: 1,
                                        padding: 0,
                                        margin: '4px 8px',
                                        background: grayDark06,
                                        cursor: 'default',
                                    }}
                                >
                                    {null}
                                </Option>
                            ) : (
                                <Option
                                    style={{ fontSize: 12 }}
                                    value={option.key}
                                    key={option.key}
                                >
                                    {option.label}
                                </Option>
                            ),
                        )}
                    </Select>
                </FilterContainer>
            </Space>
            <SpaceEnd>
                <CustomTopContainer style={{ marginTop: 0 + `px` }}>
                    <CustomPagination
                        page={page}
                        total={total}
                        changePageNumber={onPageChange}
                        handleCurrentPage={onPageInput}
                        pageSize={PAGE_SIZE}
                    />
                </CustomTopContainer>
            </SpaceEnd>
        </CustomTableSpace>
    </>
);

export default NotificationControls;
